import React from "react";
import PropTypes from "prop-types";
import { Link, useLocation } from "react-router-dom";
import queryString from "query-string";

import { isDesktop } from "shared/util/EnvironmentHelpers";
import _str from "shared/util/_str";
import PrimaryButton from "shared/components/PrimaryButton";
import { AUTHED_ROUTES } from "routers/shared/util/consts";
import { PRODUCT_SUBTYPES } from "shared/payment/constants";

const ContinueButton = ({ onClick, productId, openPaymentModal }) => {
	const ctaText = _str("Continue");
	const location = useLocation();

	if (isDesktop) {
		return (
			<PrimaryButton
				onClick={() => {
					onClick();
					openPaymentModal();
				}}
				className="alist-premium-upgrade-ratecard-continue-button"
			>
				{ctaText}
			</PrimaryButton>
		);
	}

	const oldState = queryString.parse(location.search);
	const newState = {
		productid: productId,
		type: PRODUCT_SUBTYPES.UPGRADE_ALIST,
		...oldState,
	};

	return (
		<Link
			to={{
				pathname: AUTHED_ROUTES.Payments[0],
				search: queryString.stringify(newState),
			}}
			onClick={onClick}
			className="alist-premium-upgrade-ratecard-continue-link"
		>
			{ctaText}
		</Link>
	);
};

ContinueButton.propTypes = {
	onClick: PropTypes.func.isRequired,
	productId: PropTypes.string.isRequired,
	openPaymentModal: PropTypes.func.isRequired,
};

export default ContinueButton;



// WEBPACK FOOTER //
// ./src/shared/components/AListPremiumUpgradeRateCard/ContinueButton.jsx